import { render, staticRenderFns } from "./DetailTiket.vue?vue&type=template&id=1eca8c1a&scoped=true&"
import script from "./DetailTiket.vue?vue&type=script&lang=js&"
export * from "./DetailTiket.vue?vue&type=script&lang=js&"
import style0 from "./DetailTiket.scss?vue&type=style&index=0&id=1eca8c1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eca8c1a",
  null
  
)

export default component.exports